module.exports = __webpack_public_path__ + "static/incluit-61d197abe06fbc8f3aecefd3cd290fd7.png";